import { useMemo } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

const ALL_MARKETS = 'all'

/**
 * Parses a comma-separated market uid list from the URL.
 *
 * @param {string|null|undefined} raw - Path segment or query value
 * @returns {string[]} Deduped uids; empty for `all`, empty, or missing
 */
export const parseMarketParam = (raw) => {
  if (!raw || raw === ALL_MARKETS) return []
  return [...new Set(raw.split(',').filter(Boolean))]
}

/**
 * useSelectedMarkets
 *
 * The selected market uids, read from the URL only. The `:market` path
 * segment wins, then the `?market=` query used on routes without a market
 * segment.
 *
 * @returns {{ selectedMarkets: string[], marketsCsv: string }}
 *   `marketsCsv` is the comma-joined list, or `all` when nothing is selected
 */
export const useSelectedMarkets = () => {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const raw = params.market ?? searchParams.get('market')

  return useMemo(() => {
    const selectedMarkets = parseMarketParam(raw)
    const marketsCsv =
      selectedMarkets.length > 0 ? selectedMarkets.join(',') : ALL_MARKETS
    return { selectedMarkets, marketsCsv }
  }, [raw])
}
